<ul class="error-list" color="warn" *ngIf="errors">
  <li *ngFor="let error of errors">{{ error?.message }}</li>
</ul>
